import React, { useState } from "react";
import { useDataManager } from "../backend/DataManager";
import tierHeader from "../tiers/tierHeader"
import "../design/existingUser.css"
import axiosWithHandling from "../backend/axiosHanding";
import { apiURL } from "../backend/ApiURLs";
import { useNavigate } from "react-router-dom";

export default function Login() {
    const {customerID, setCustomerID, productName, setProductName, isFoundersClub, setIsFoundersClub} = useDataManager();

    const [emailOrUsername, setEmailOrUsername] = useState("")
    const [password, setPassword] = useState("")

    const [errorMessage, setErrorMessage] = useState(null);    
    const [isSubmitting, setIsSubmitting] = useState(false);

    var sha256 = require('js-sha256');
    const hashedPassword = sha256(password)

    const url = `${apiURL}verification/validateCredentialsForReturningUser?emailOrUsername=${encodeURIComponent(emailOrUsername)}&password=${encodeURIComponent(hashedPassword)}`

    const navigate = useNavigate();

        const sendLoginRequestForExistingUserRenewalDetailsObject = async () => {
        setIsSubmitting(true)
        const isValidInputs = validateInputs(emailOrUsername, password)

        if (isValidInputs != "") {
            setErrorMessage(isValidInputs)
            setIsSubmitting(false)
            return
        }

        axiosWithHandling(url)
        .then(response => {
            setIsSubmitting(false)
            setCustomerID(response.customerID)
            setIsFoundersClub(response.isFoundersClub)
            // console.log(response) commented out for production
            // console.log(response.isFoundersClub)
            navigate('/existingUser/checkout')
        })
        .catch(error => {
            setIsSubmitting(false)
            var statusCode = error.message

            setErrorMessage(validateResponseFromServer(statusCode))
        })

    }
    /**
     * @deprecated Server no longer returns a raw string.
     * Use `sendLoginRequestForExistingUserRenewalDetailsObject` instead.
     */
    const sendLoginRequestForCustomerIDString = async () => {
        setIsSubmitting(true)
        const isValidInputs = validateInputs(emailOrUsername, password)

        if (isValidInputs != "") {
            setErrorMessage(isValidInputs)
            setIsSubmitting(false)
            return
        }

        axiosWithHandling(url)
        .then(data => {
            setIsSubmitting(false)
            setCustomerID(data)
            navigate('/existingUser/checkout')
        })
        .catch(error => {
            setIsSubmitting(false)
            var statusCode = error.message

            setErrorMessage(validateResponseFromServer(statusCode))
        })

    }


    const validateInputs = (emailOrUsername, password) => {
        if (emailOrUsername == "") {
            return "Email or Username cannot be empty"
        }

        if (password == "") {
            return "Password cannot be empty"
        }

        return ""

    }

    const validateResponseFromServer = (statusCode) => {
        if (statusCode == 401) {
            return "Incorrect Email or Password"
        }

        if (statusCode == 409) {
            return "It looks like you've already signed up through Apple. Please restart your subscription directly from our App.";
        }

        if (statusCode == 417) {
            return "Cannot find customerID for user. Please contact support";
        }

        if (statusCode == 411) {
            return "It looks like you already have an active subscription. Manage your subscription using https://billing.stripe.com/p/login/3csbLda5e6053EA7ss";
        }

        return `Unkown error: ${statusCode}`

    }

    return(
        <>
        <h1 className="header"> Renew Your Subscription </h1>

        <div className="background">

        <label>
            Email or Username
            <input type="email" onChange={(e) => setEmailOrUsername(e.target.value)}></input>
        </label>

        <label>
            Password
            <input type="password" onChange={(e) => setPassword(e.target.value)}></input>
        </label>

        <div className="errorMessage">
                    {errorMessage}
        </div>     

            
        <button className="submitButton" onClick={sendLoginRequestForExistingUserRenewalDetailsObject} disabled={isSubmitting}>
                {isSubmitting ? "Logging In" : "Log in"}
        </button>

        <h3 onClick={() => navigate("/resetYourPassword")} className="reset-password-link">
            Reset Password
        </h3>

        </div>

        </>
        
    )
}